import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/poppins/300.css'; // Light
import '@fontsource/poppins'; // Defaults to weight 400
import '@fontsource/poppins/500.css'; // Medium
import '@fontsource/poppins/600.css'; // Semi-Bold
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from './stores';

// Register the service worker at page load
if (
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.protocol === "https:") &&
  'serviceWorker' in navigator
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(_ => console.log('SW registered successfully:'))
      .catch(err => console.error('SW failed:', err));
  });
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as any
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
